module.exports = __webpack_public_path__ + "static/martha-stories-inventions-b1c9336059081d86b4c3e3354914a0af.webm";